import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import BaseCard from '@/features/global/BaseCard.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'SkillsPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(BaseCard, {
      title: 'Skills',
      highlightLastWord: false
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "grid lg:grid-cols-3 gap-4 place-items-center" }, [
          _createElementVNode("div", { class: "w-full" }, [
            _createElementVNode("h2", { class: "text-2xl font-bold" }, "Languages"),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, "Python"),
              _createElementVNode("li", null, "C++"),
              _createElementVNode("li", null, "Java"),
              _createElementVNode("li", null, "JavaScript"),
              _createElementVNode("li", null, "SQL")
            ])
          ]),
          _createElementVNode("div", { class: "w-full" }, [
            _createElementVNode("h2", { class: "text-2xl font-bold" }, "Frameworks"),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, "PyTorch"),
              _createElementVNode("li", null, "sklearn"),
              _createElementVNode("li", null, "CV2"),
              _createElementVNode("li", null, "Vue.js"),
              _createElementVNode("li", null, "PostgreSQL")
            ])
          ]),
          _createElementVNode("div", { class: "w-full" }, [
            _createElementVNode("h2", { class: "text-2xl font-bold" }, "Hobbies & Others"),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, "Rock Climbing"),
              _createElementVNode("li", null, "Creative Writing"),
              _createElementVNode("li", null, "Floral Design"),
              _createElementVNode("li", null, "Project Leadership"),
              _createElementVNode("li", null, "Community Engagement")
            ])
          ])
        ], -1)
      ])),
      _: 1
    }),
    _createVNode(BaseCard, {
      title: 'BoxCast',
      highlightLastWord: true
    }, {
      default: _withCtx(() => _cache[1] || (_cache[1] = [
        _createElementVNode("div", { class: "flex flex-col justify-center gap-4" }, [
          _createElementVNode("div", { class: "w-full grid gap-2 lg:grid-cols-2 lg:gap-20" }, [
            _createElementVNode("h5", { class: "lg:justify-self-end lg:pr-6 font-medium" }, "Software Engineering Intern"),
            _createElementVNode("h5", { class: "lg:justify-self-start lg:pl-6 font-medium" }, "December 2023 - October 2025")
          ]),
          _createElementVNode("p", { class: "text-center px-4 gap-2" }, [
            _createElementVNode("span", { class: "block" }, " While at BoxCast, I had the privilege to develop RemoteMix, BoxCast's newest product, from its earlist prototyping stages to its release and future updates. Working primarily in Vue.js and Go, we created a fully remote audio mixing solution compatible with 23 major audio mixers, replicating physical audio mixers on the BoxCast platform in our own design. "),
            _createElementVNode("span", { class: "block" }, [
              _createTextVNode(" My primary work involved Virtual Groups for 23 mixers and Channel Processing for 5, two of RemoteMix's largest and most used features. Virtual Groups allow users to control "),
              _createElementVNode("span", { class: "font-bold" }, "infinite"),
              _createTextVNode(" channels at once in groups while Channel Processing allows users to control the PEQ, Gate, Compression, and RTA modules on their mixer from anywhere in the world. While working on this product, I had the privilege to collaborate cross-functionally across nearly every team at BoxCast, including my main software engineering team, marketing, UX, QA, and product managers to deliver a product best fit for our users. ")
            ])
          ]),
          _createElementVNode("div", { class: "flex flex-col lg:flex-row items-center justify-center gap-6" }, [
            _createElementVNode("iframe", {
              class: "w-full max-w-[32rem] aspect-video",
              src: "https://www.youtube.com/embed/_i1t7UGDRkE",
              allowfullscreen: ""
            }),
            _createElementVNode("iframe", {
              class: "w-full max-w-[32rem] aspect-video",
              src: "https://www.youtube.com/embed/-zUUdGRZ7oQ",
              allowfullscreen: ""
            })
          ])
        ], -1)
      ])),
      _: 1
    })
  ]))
}
}

})